import React from 'react';

// Home base ({ name, lat, lon }) — the user's chosen origin for all distance
// labels. Provided by App; read wherever a card/row/modal shows a distance.
export const HomeBaseContext = React.createContext(null);
export function useHomeBase() { return React.useContext(HomeBaseContext); }
